import React from 'react'
import { css } from '@emotion/core'
import { H2, LayoutBand, Separator, Tab, Tabs } from '@fs/zion-ui'

import PhilippinesMapTab from './PhilippinesMapTab'

// CSS to adjust the tabs to better align with the map card.
// Note that this can break at any time if the underlying Tabs implementation changes.
const tabHeaderCss = css`
  [data-reach-tabs] > div[class*='bleedCss'] {
    margin-inline-start: 8px;
  }
`

export default function RecordMapSection({ isLoading, provinces, surname = '' }) {
  const recordTotal = provinces?.reduce((sum, province) => sum + (province.recordCount || 0), 0) || 0

  if (!recordTotal) {
    return null
  }

  return (
    <LayoutBand maxWidth="md" marginY="xxl">
      <H2 supplementary centered balanced>
        {surname} Was Found {recordTotal.toLocaleString()} Times in FamilySearch Records
      </H2>
      <Separator size="lg" />
      <div css={tabHeaderCss}>
        <Tabs>
          <Tab title="FamilySearch Records" data-testid="records-tab" index="records">
            <PhilippinesMapTab tabName="records" isLoading={isLoading} provinces={provinces} surname={surname} />
          </Tab>
          <Tab title="2020 Population" data-testid="population-tab" index="population">
            <PhilippinesMapTab tabName="population" isLoading={isLoading} provinces={provinces} surname={surname} />
          </Tab>
        </Tabs>
      </div>
    </LayoutBand>
  )
}
